import { useEffect } from "react";
import { useAuth } from "@/contexts/auth-context";
import { sanitizeColor } from "@/lib/sanitize-color";

export function useBranding() {
	const { user } = useAuth();

	useEffect(() => {
		const root = document.documentElement;

		const primary = sanitizeColor(user?.primary_color ?? "");
		if (primary) {
			root.style.setProperty("--brand-primary", primary);
		} else {
			root.style.removeProperty("--brand-primary");
		}

		const secondary = sanitizeColor(user?.secondary_color ?? "");
		if (secondary) {
			root.style.setProperty("--brand-secondary", secondary);
		} else {
			root.style.removeProperty("--brand-secondary");
		}
	}, [user?.primary_color, user?.secondary_color]);
}
